import { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "../../styles/solution-carousel.css";
import CustomDot from './CustomDot';
import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const CustomCarousel = () => {
    const [isMobile, setIsMobile] = useState(false);
    const { t } = useTranslation();
    const [selectedSlide, setSelectedSlide] = useState(0);
    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        afterChange: (current) => setSelectedSlide(current),

        cssEase:'ease-in-out',
        responsive: [
            {
            breakpoint: 1000,
            settings: {
                centerMode: true,
                centerPadding: '10%',
                slidesToShow: 3,
            }
            },
            { breakpoint: 768,
            settings: {
                centerMode: true,
                centerPadding: '10%',
                slidesToShow: 1,
            }
            },
            {
            breakpoint: 480,
            settings: {
                centerMode: true,
                centerPadding: '10%',
                slidesToShow: 1
            }
            }
        ]
    };

    const slides = [
        {
            image: 'https://res.cloudinary.com/vantagecircle/image/upload/v1704949817/VantageFit/2023/carousel-_step.png',
            heading1: 'Step Up Your Wellness',
            heading2: 'Promote physical activity and boost employee engagement with step-tracking challenges.', url: '/steps-challenge/',
            dotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1699340014/VantageFit/2023/step_challenge.svg',
            activeDotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1706790222/VantageFit/2023/step_challenge_clr.svg',
            text: 'Steps Challenge'
        },
        {
            image: 'https://res.cloudinary.com/vantagecircle/image/upload/v1704949810/VantageFit/2023/carousel-multiactivity.png',
            heading1: 'Multi-Activity Challenges for Total Fitness',
            heading2: 'Empower Employees with a Variety of Fitness Tasks Tailored to Individual Preferences.',
            url: '/multi-activity-challenges/',
            dotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1699360829/VantageFit/2023/multi_activity_challenge.svg',
            activeDotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1706792426/VantageFit/2023/multi_activity_challenge_clr.svg',
            text: 'Multi-activity Challenges'
        },
        {
            image: 'https://res.cloudinary.com/vantagecircle/image/upload/v1704949816/VantageFit/2023/carousel-_-team.png',
            heading1: 'Promote Togetherness',
            heading2: 'Foster Teamwork, Collaboration, and Healthy Competition with Group Fitness Activities.',
            url: '/team-challenges/',
            dotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1699340014/VantageFit/2023/team_challenge.svg',
            activeDotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1706792514/VantageFit/2023/team_challenge_clr.svg',
            text: 'Team Challenge'
        },
        {
            image: 'https://res.cloudinary.com/vantagecircle/image/upload/v1704949810/VantageFit/2023/carousel-remote.png',
            heading1: 'Unlock Wellness for Remote Teams',
            heading2: 'Address the unique wellness challenges of remote workforces effectively.',
            url: '/remote-team-wellness/',
            dotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1699340013/VantageFit/2023/remote_team_wellness.svg',
            activeDotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1706792576/VantageFit/2023/remote_team_wellness_clr.svg',
            text: 'Remote Team Wellness'
        },
        {
            image: 'https://res.cloudinary.com/vantagecircle/image/upload/v1704949810/VantageFit/2023/carousel-global.png',
            heading1: 'Engaging Employees Worldwide!',
            heading2: 'Tailored initiatives for multi-national companies, embracing diversity in every step.',
            url: '/global-employee-engagement/',
            dotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1699339980/VantageFit/2023/global_employee_engagement.svg',
            activeDotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1706792576/VantageFit/2023/global_employee_engagement_clr.svg',
            text: 'Global Employee Engagement'
        },
        {
            image: 'https://res.cloudinary.com/vantagecircle/image/upload/v1704949811/VantageFit/2023/carousel-mental.png',
            heading1: 'Ascend to Well-Being',
            heading2: 'Empower your employees with resources and initiatives to nurture their emotional wellness.',
            url: '/mental-health-and-wellbeing-challenges/',
            dotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1699340013/VantageFit/2023/mental_health_and_wellbeing.svg',
            activeDotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1706792576/VantageFit/2023/mental_health_and_wellbeing_clr.svg',
            text: 'Mental Health & Well-being'
        },
        {
            image: 'https://res.cloudinary.com/vantagecircle/image/upload/v1704949810/VantageFit/2023/carousel-holistic.png',
            heading1: 'Embracing Total Wellbeing',
            heading2: 'Integrate Physical, Mental, and Emotional Wellness for a Comprehensive Employee Well-being Approach.',
            url: '/holistic-wellness-program/',
            dotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1699360829/VantageFit/2023/Holistic.svg',
            activeDotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1706792576/VantageFit/2023/Holistic_clr.svg',
            text: 'Holistic Wellness Program'
        },
        {
            image: 'https://res.cloudinary.com/vantagecircle/image/upload/v1704949816/VantageFit/2023/carousel-rewards.png',
            heading1: 'Reward Wellness to Foster Healthy Habits',
            heading2: 'Motivate and celebrate healthy behaviors with tailored rewards and recognition.',
            url: '/wellness-rewards-program/',
            dotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1699360831/VantageFit/2023/wellness_rewards.svg',
            activeDotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1706792578/VantageFit/2023/wellness_rewards_clr.svg',
            text: 'Wellness Rewards Program'
        },
        {
            image: 'https://res.cloudinary.com/vantagecircle/image/upload/v1704949811/VantageFit/2023/carousel-analytics.png',
            heading1: 'Data-Driven Wellness',
            heading2: 'Track, analyze and improve employee health metrics with comprehensive insights.',
            url: '/health-fitness-analytics/',
            dotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1699360829/VantageFit/2023/Health_analytics.svg',
            activeDotImage: 'https://res.cloudinary.com/vantagecircle/image/upload/v1706792574/VantageFit/2023/Health_analytics_clr.svg',
            text: 'Health & Fitness Analytics'
        },

    ];

    const handleDotClick = (index) => {
        setSelectedSlide(index);
        sliderRef.current.slickGoTo(index); // Use slickGoTo to set the active slide
    };
    const handlePrevious = () => {
        sliderRef.current.slickPrev();
    };

    const handleNext = () => {
        sliderRef.current.slickNext();
    };
    const renderPaging = () => {
        return slides.map((slide, index) => (
            <CustomDot
            key={index}
            index={index}
            selected={index === selectedSlide}
            onClick={handleDotClick}
            dotImage={index === selectedSlide ? slide.activeDotImage : slide.dotImage}
            text={slide.text}
            lazyLoad={true}
            />
        ));
    };
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className='position-relative'>
            {!isMobile && <div className="custom-paging">{renderPaging()}</div>}
            <Slider className="soln-slider" ref={sliderRef} {...settings}>
                {slides.map((slide, index) => (
                <div key={index} className="carousel-slide">
                    <div className="slide-content text-center">
                        <p className="slide-heading1 text-truncate">{t(slide.heading1)}</p>
                        <p className="slide-heading2">{t(slide.heading2)}</p>
                        <a href={t(`${slide.url}`)}><Trans>Explore</Trans> >></a>
                    </div>
                    <img loading="lazy" decoding="async" src={slide.image} alt={`Slide ${index + 1}`} />
                </div>
                ))}
            </Slider>
            <button onClick={handlePrevious} className="prevbtn"><img loading="lazy" decoding="async" src="https://res.cloudinary.com/vantagecircle/image/upload/v1695206356/VantageFit/2023/next.svg" /></button>
            <button onClick={handleNext} className="nextbtn"><img loading="lazy" decoding="async" src="https://res.cloudinary.com/vantagecircle/image/upload/v1695206356/VantageFit/2023/next.svg" /></button>

        </div>
      );
    };

    export default CustomCarousel;
